module.exports = __webpack_public_path__ + "img/ic-square-online.dbcca8b0.svg";